import React from "react";
import { useApp } from "@/context/AppContext";
import { Quote, Star, ExternalLink } from "lucide-react";
import { SOCIAL, REVIEWS } from "@/config/links";
import { externalLinkHandler, externalTarget } from "@/utils/openExternal";

export default function About() {
  const { t } = useApp();
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="ht-section border-t"
      style={{ borderColor: "var(--ht-border)" }}
    >
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-5">
          <img
            src="https://customer-assets.emergentagent.com/job_homeatope-academy/artifacts/wpkmrjll_WhatsApp%20Image%202026-05-19%20at%2017.57.26.jpeg"
            alt="Gerardo Salvo · Fundador de Home a tope"
            data-testid="about-image"
            className="ht-card h-full w-full rounded-xl object-cover"
            style={{ aspectRatio: "4/5", objectPosition: "center" }}
            loading="lazy"
          />
        </div>
        <div className="flex flex-col lg:col-span-7">
          <p className="ht-eyebrow">{t.about.eyebrow}</p>
          <h2
            className="mt-3 text-3xl font-bold sm:text-4xl"
            style={{ color: "var(--ht-text)" }}
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
          <p
            className="mt-2 text-sm uppercase tracking-[0.18em]"
            style={{ color: "var(--ht-accent)" }}
          >
            {t.about.role}
          </p>
          <div className="mt-6 flex gap-4">
            <Quote
              className="shrink-0"
              size={28}
              style={{ color: "var(--ht-primary)" }}
            />
            <p
              className="text-base leading-relaxed sm:text-lg"
              style={{ color: "var(--ht-text-muted)" }}
            >
              {t.about.body}
            </p>
          </div>

          {/* Google reviews card */}
          <a
            href={SOCIAL.googleReviews}
            target={externalTarget()}
            rel="noopener noreferrer"
            onClick={externalLinkHandler(SOCIAL.googleReviews)}
            data-testid="about-google-reviews"
            className="ht-card group mt-8 flex items-center gap-4 self-start rounded-xl p-4 pr-5 transition-all"
          >
            {/* Google G */}
            <span
              className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full"
              style={{ backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.12)" }}
              aria-hidden
            >
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"/>
              </svg>
            </span>
            <div className="flex flex-col leading-tight">
              <div className="flex items-baseline gap-2">
                <span
                  className="text-xl font-bold"
                  style={{ color: "var(--ht-text)" }}
                  data-testid="reviews-rating"
                >
                  {REVIEWS.rating.toFixed(1).replace(".", ",")}
                </span>
                <span className="flex gap-0.5" aria-hidden>
                  {[0, 1, 2, 3, 4].map((i) => (
                    <Star
                      key={i}
                      size={14}
                      fill="#FBBC05"
                      strokeWidth={0}
                    />
                  ))}
                </span>
              </div>
              <span
                className="text-xs"
                style={{ color: "var(--ht-text-muted)" }}
              >
                {t.about.reviewsTitle}
              </span>
              <span
                className="mt-1 inline-flex items-center gap-1 text-xs font-semibold group-hover:underline"
                style={{ color: "var(--ht-primary)" }}
              >
                {t.about.reviewsCta}
                <ExternalLink size={12} />
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
